"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ThemedButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../ThemeProvider");

var _Button = _interopRequireDefault(require("react-bootstrap/lib/Button"));

var _style = _interopRequireDefault(require("./style"));

var _types = require("./types");

var _propTypes = _interopRequireDefault(require("prop-types"));

var StiloButton = function StiloButton(_ref) {
  var id = _ref.id,
      classes = _ref.classes,
      size = _ref.size,
      kind = _ref.kind,
      ripple = _ref.ripple,
      text = _ref.text,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["id", "classes", "size", "kind", "ripple", "text", "children"]);
  var className = classes.Button.concat(ripple === false ? '' : ' ripple');

  if (size !== 'default') {
    props.bsSize = size;
  }

  return /*#__PURE__*/React.createElement(_Button["default"], (0, _extends2["default"])({
    id: id,
    className: className,
    bsStyle: kind
  }, props), children ? children : text);
};

StiloButton.propTypes = _types.bpfrpt_proptype_StiloButtonProps === _propTypes["default"].any ? {} : _types.bpfrpt_proptype_StiloButtonProps;
var ThemedButton = (0, _ThemeProvider.withStyles)(_style["default"])(StiloButton);
exports.ThemedButton = ThemedButton;
var _default = ThemedButton;
exports["default"] = _default;
//# sourceMappingURL=bootstrap.js.map